import React from 'react';
import IconCheckmark from '../../../../UI/Icons/IconCheckmark';
import {useDispatch, useSelector} from 'react-redux';
import translationActions from '../../../../../store/actions/language';
import categoriesActions from '../../../../../store/actions/categoriesActions';
import cls from 'classnames';
import styles from './Lang.module.scss';
import {useRouter} from 'next/router';

function Lang({closeDropdown}) {
  const { language, languageList } = useSelector((state) => state.language);
  const dispatch = useDispatch();
  const router = useRouter();

  const switchLanguageHandler = (code) => {
    dispatch(translationActions.setLanguage(code));
    const headers = {};
    headers['accept-language'] = code;
    dispatch(categoriesActions.getCategories(headers));
    closeDropdown();
    router.push(router.pathname, router.asPath, { locale: code.split('-')[0] });
  };

  return (
    <div className={styles.lang}>
      {
        languageList.map((el) => (
          <div
            className={cls(styles.langBtn, {[styles.selected]: language === el.code})}
            onClick={() => switchLanguageHandler(el.code)}
          >
            {el.title}
            <IconCheckmark color="#4579F5" />
          </div>
        ))
      }
    </div>
  );
}

export default Lang;
